<template>
  <div v-if="formattedNodes.length > 0" class="shopping-cart-item-modifiers-tree">
    <cart-list-item-modifiers-line
      v-for="node in formattedNodes"
      :key="node.itemSetId + node.name"
      :name="node.name"
      :cost="node.cost"
      :nodes="node.nodes"
      :formatter="formatNodes"
      :level="1"
      :type="type"
    >
    </cart-list-item-modifiers-line>
  </div>
</template>

<script>
import CartListItemModifiersLine from "./cart-list-item-modifiers-line/CartListItemModifiersLine";
import { PRICING_MODE } from "@/../app-constants";

export default {
  name: "CartListItemModifiersTree",
  components: {
    CartListItemModifiersLine
  },
  props: {
    item: Object,
    type: String
  },
  computed: {
    formattedNodes() {
      return this.formatNodes(this.item.modifierGroups);
    }
  },
  methods: {
    hasInstruction(modifier) {
      return (modifier.modifierGroups && modifier.modifierGroups[0]?.isInstruction) || false;
    },
    createSingleLineNode(modifier) {
      let nodes = modifier.modifierGroups;
      let name = modifier.name;
      if (this.hasInstruction(modifier)) {
        const instructions = modifier.modifierGroups.find((value) => value.isInstruction);
        const selectedInstructions = instructions.modifiers.filter((instruction) =>
          instructions.selectedModifiers?.includes(instruction.modifierId)
        );
        if (selectedInstructions.length > 0) {
          const allInstructions = selectedInstructions.map((instruction) => instruction.name).join(", ");
          name = `${modifier.name} (${allInstructions})`;
        }
        nodes = [];
      }

      return {
        name,
        nodes,
        cost: modifier.cost,
        type: this.type
      };
    },
    formatNodes(modifierGroups) {
      if (!modifierGroups) return [];
      return modifierGroups.reduce((nodes, modifierGroup) => {
        const { singleLineMods, modsToGroup } = modifierGroup.modifiers.reduce(
          (acc, modifier) => {
            if (!modifierGroup.selectedModifiers?.includes(modifier.modifierId)) return acc;

            const isIncludedInParentPrice = modifier.rules.pricingMode === PRICING_MODE.includedInParentPrice;
            const hasCost = modifier.cost > 0;
            const shouldDisplayCost = hasCost && !isIncludedInParentPrice;
            const hasModifierGroups = modifier.modifierGroups?.length > 0;

            if (shouldDisplayCost || hasModifierGroups) {
              // Add a single line Modifier
              return {
                singleLineMods: [...acc.singleLineMods, this.createSingleLineNode(modifier)],
                modsToGroup: acc.modsToGroup
              };
            }
            // Add a modifier to be grouped in the format "(mod1, mod2, ...modN)""
            return {
              singleLineMods: acc.singleLineMods,
              modsToGroup: [...acc.modsToGroup, modifier.displayName]
            };
          },
          { singleLineMods: [], modsToGroup: [] }
        );

        if (modsToGroup.length > 0)
          singleLineMods.push({
            name: modsToGroup.join(", "),
            cost: 0,
            nodes: [],
            type: this.type
          });

        return [...nodes, ...singleLineMods];
      }, []);
    }
  }
};
</script>
